import React from "react";
import { useSelector } from "react-redux";
import { Table } from "react-bootstrap";
import { selectWarningReport } from "../../../redux/selectors";

const WarningReports = () => {
    const warningReportList = useSelector(selectWarningReport);

    const getRowStyle = (warningText) => {
        if (!warningText) {
            return { backgroundColor: "inherit" };
        }
        const lowerCaseText = warningText.toLowerCase();
        if (lowerCaseText.startsWith("warning")) {
            return { backgroundColor: "lightcoral" };
        } else if (lowerCaseText.startsWith("note")) {
            return { backgroundColor: "white" };
        } else if (lowerCaseText.startsWith("caution")) {
            return { backgroundColor: "lightyellow" };
        } else if (lowerCaseText.startsWith("exception")) {
            return { backgroundColor: "lightblue" };
        } else {
            return { backgroundColor: "inherit" };
        }
    };

    return (
        <div>
            <div style={{ marginBottom: "10px", textAlign: "right" }}>
                <div style={{ display: "flex", flexDirection: "row", gap: "10px", justifyContent: "flex-end" }}>
                    <span style={{ backgroundColor: "lightcoral", padding: "2px 5px" }}>Warning</span>
                    <span style={{ backgroundColor: "white", padding: "2px 5px" }}>Note</span>
                    <span style={{ backgroundColor: "lightyellow", padding: "2px 5px" }}>Caution</span>
                </div>
            </div>
            <Table striped bordered hover>
                <tbody>
                    {warningReportList
                        .filter(warningReportItem => warningReportItem.WarningText && !warningReportItem.WarningText.toLowerCase().startsWith("exception"))
                        .map((warningReportItem, index) => (
                            <tr key={index}>
                                <td style={getRowStyle(warningReportItem.WarningText)}>{warningReportItem.WarningText}</td>
                            </tr>
                        ))}
                </tbody>
            </Table>
        </div>
    );
};

export default WarningReports;
